import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-list',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './list.template.component.html',
  styleUrls: ['./list.template.component.scss']
})
export class SkeletorListTemplateComponent {
  @Input() items: number = 5;
  get rows() { return Array.from({ length: this.items }); }
}

